import Vue from 'vue';
import Router from 'vue-router';
// import multiguard from 'vue-router-multiguard';
// import {
//   OnlyAuthorisedAccessGuard,
//   OnlyProfileOwnerAccessGuard,
//   OnlyIfMatchmakingIsIDLEAccessGuard,
//   RestrictedAreaAccessGuard,
// } from './guards';

const Landing = () => import(/* webpackChunkName: "Landing", webpackPrefetch: true  */ '../../components/Landing.vue');


Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    meta: {
      title: `Landing | Home`,
    },
  },
  
];

const router = new Router({
  mode: 'history',
  routes,
});

export default router;
